<app-table
    #ePrescriptions
    [translatePrefix]="prefix"
    [columns]="columns"
    [items]="items()"
    selectionMode="single"
    (selectionChanged)="selection($event)"
    [showSearchBar]="false"
>

    <ng-template pTemplate="issuedAt" let-item="item">
        @if (item.id > 0) {
            <div>{{ item.issuedAt | localDate }}</div>
        }
    </ng-template>

<!--    <ng-template pTemplate="status" let-item="item" let-data="data">-->
<!--        @if (item.id > 0) {-->
<!--            <div class="flex-column">-->
<!--                <app-tag [label]="data"></app-tag>-->
<!--            </div>-->
<!--        }-->
<!--    </ng-template>-->

    <ng-template pTemplate="medications" let-item="item" let-data="data">
        @if (item.id > 0) {
            <div class="flex-column">
                @if (item.magistraliter) {
                    <div class="flex align-items-center">
                        <span>{{ item.magistraliter.amount }}× {{ item.magistraliter.name }}</span>
                    </div>
                } @else if (data[0]) {
                    <div class="flex align-items-center">
                        <span>{{ data[0].amount }}×</span>
                        <app-medication-info [medicationCode]="data[0].code"></app-medication-info>
                    </div>
                }
                @if (data[1]) {
                    <div class="flex align-items-center">
                        <span>{{ data[1].amount }}×</span>
                        <app-medication-info [medicationCode]="data[1].code"></app-medication-info>
                    </div>
                }
            </div>
        } @else {
            <div class="font-bold">{{ prefix + 'labels.new' | translate }}</div>
        }
    </ng-template>
</app-table>
